export default __webpack_public_path__ + "images/55f73ecd5c020e93bf0c2b9e55d0d0df-info.svg";